import React from 'react'
import { SustainableEventBannerCompact } from './SustainableEventBannerCompact'
import { SustainableEventBannerLarge } from './SustainableEventBannerLarge'
import { SustainableEventIcon } from './Icons'
import { useSustainableEventBannerWrapperGetJourneysForSourceQuery } from './SustainableEventBannerWrapper.generated-types'

interface SustainableEventBannerWrapperProps {
  eventUUID: string
  marginLeft?: number | null
  marginTop?: number | null
  marginBottom?: number | null
  children?: React.ReactNode | null
  showIconInsideBanner?: boolean
}

export const SustainableEventBannerWrapper = ({
  eventUUID,
  marginLeft = null,
  marginTop = null,
  children = null,
  showIconInsideBanner = true,
}: SustainableEventBannerWrapperProps): JSX.Element | null => {
  const [{ fetching, data: journeysForSourceQueryData }] =
    useSustainableEventBannerWrapperGetJourneysForSourceQuery({
      variables: { input: { sourceId: eventUUID } },
      requestPolicy: 'cache-and-network',
    })

  if (fetching) {
    return null
  }

  const hasExistingJourneys =
    journeysForSourceQueryData?.getJourneysForSource.length > 0

  if (hasExistingJourneys) {
    return (
      <div style={{ marginLeft, marginTop }}>
        {children}
        <SustainableEventBannerCompact eventUUID={eventUUID} />
      </div>
    )
  }

  if (showIconInsideBanner) {
    return (
      <div style={{ marginLeft, marginTop }}>
        {children}
        <SustainableEventBannerLarge eventUUID={eventUUID} />
      </div>
    )
  }

  return (
    <div
      style={{
        marginLeft,
        marginTop,
        display: 'flex',
        lineHeight: '24px',
      }}
    >
      <div>
        {children}
        <SustainableEventBannerLarge eventUUID={eventUUID} showIcon={false} />
      </div>
      <div style={{ marginLeft: '4px', marginTop: '8px' }}>
        <SustainableEventIcon />
      </div>
    </div>
  )
}
